import { queryOptions } from '@tanstack/react-query'

import { KompisDefaultFields } from '@inter-ikea-kompis/core/services'
import type { IDexfSettings } from '@inter-ikea-kompis/core/types'

import { getProducts } from '@sofa-platform/dexf-utils'
import type { ItemId } from '@sofa-platform/types'

import { DEXF_API_KEY } from '@/integrations/kompis/constants'

export function productDataQueryOptions(items: ItemId[] | undefined, dexfAppSettings: IDexfSettings | undefined) {
  return queryOptions({
    enabled: !!dexfAppSettings && !!items,
    queryFn: () => fetchProductData(items, dexfAppSettings),
    queryKey: ['product-data'],
    staleTime: Infinity,
  })
}

async function fetchProductData(items: ItemId[] | undefined, dexfAppSettings: IDexfSettings | undefined) {
  if (!dexfAppSettings || !items) return []
  const rangeProductData = await getProducts(items, {
    basePath: dexfAppSettings.kompis.endpoints.dexfWebplannerService,
    dexfApiKey: DEXF_API_KEY,
    fields: Object.values(KompisDefaultFields),
  })

  return rangeProductData
}
